import React, { useState } from "react"
import { loading, logging, integrationSheets, teamStatus, message } from "state_management"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import useT from "utils/hooks/useT"

import { ConfirmDialog, Popup } from "components"
import { ReportConfig } from "components/Config"
import Button from "react-bootstrap/Button"
import Form from "react-bootstrap/Form"


import ToggleButton from "react-bootstrap/ToggleButton"
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup"
import { Title, Container} from "components/Form"
import LogTable from "components/LogTable"

import "./index.scss"
export default function SimulationTab() {
  const dispatch = useDispatch()
  const location = useLocation()
  const { t } = useT("messages")
  const { t: tc } = useT("common")

  const isInPlanningMode = useSelector((state) => state.teamStatus.isInPlanningMode)
  const isCurrentPlanner = useSelector((state) => state.teamStatus.isCurrentPlanner)
  const isAnalyses = useSelector((state) => state.teamStatus.showAnalyses)
  const isProjects = useSelector((state) => state.teamStatus.showProjects)
  const taskLog = useSelector((state) => state.logging.taskLog)
  const instrumentLog = useSelector((state) => state.logging.instrumentLog)
  const sampleLog = useSelector((state) => state.logging.sampleLog)
  const allowTaskTransfer = useSelector((state) => state.teamStatus.allowTaskTransfer)
  const directToMemberPlan = useSelector((state) => state.teamStatus.directToMemberPlan)
  const teamId = useSelector((state) => state.auth.teamId)


  const [activeConfirmHandler, setActiveConfirmHandler] = useState(null)
  const [activeConfirmTitle, setActiveConfirmTitle] = useState(null)
  const [activeConfirm, setActiveConfirm] = useState(false)
  const [showLog, setShowLog] = useState(false)
  const [showReport, setShowReport] = useState(false)
  const [logViewType, setLogViewType] = useState("task")
  const [sampleSearchTerm, setSampleSearchTerm] = useState("")

  const otherPlannerInitials = useSelector((state) => {
    const currentPlannerId = state.teamStatus.currentPlannerId
    if (currentPlannerId === "self") {
      return null
    } else if (currentPlannerId) {
      return state.members[currentPlannerId].initials
    } else {
      return null
    }
  })

  return (
    <div className="simulation-tab">
      {showReport && (
        <Popup
          onCancel={() => setShowReport(false)}
          className="report-popup"
        >
          <ReportConfig onClose={() => setShowReport(false)} id={teamId} />
        </Popup>
      )}

      {showLog && (
        <Popup
          title={tc("changeLogs")}
          onCancel={() => {
            setShowLog(false)
            setLogViewType("task")
            setSampleSearchTerm("")
          }}
          className="log-popup"
        >
          {logViewType === "sample" && (
            <div className="log-search-container">
              <Form.Control
                type="text"
                placeholder={tc("searchBySampleName")}
                value={sampleSearchTerm}
                onChange={(e) => setSampleSearchTerm(e.target.value)}
                className="log-search-input"
              />
            </div>
          )}
          <div className="log-header-container">
            <div className="log-view-tabs">
              <div
                className={`log-tab ${logViewType === "task" ? "active" : ""}`}
                onClick={() => setLogViewType("task")}
              >
                {tc("taskLog")}
              </div>
              <div
                className={`log-tab ${logViewType === "instrument" ? "active" : ""}`}
                onClick={() => setLogViewType("instrument")}
              >
                {tc("instrumentLog")}
              </div>
              <div
                className={`log-tab ${logViewType === "sample" ? "active" : ""}`}
                onClick={() => setLogViewType("sample")}
              >
                {tc("sampleLog")}
              </div>
            </div>
          </div>
          <LogTable
            log={logViewType === "task" ? taskLog : logViewType === "instrument" ? instrumentLog : sampleLog}
            viewType={logViewType}
            searchTerm={logViewType === "sample" ? sampleSearchTerm : ""}
          />
        </Popup>
      )}
      {activeConfirm && (
        <ConfirmDialog
          onCancel={() => setActiveConfirm(false)}
          onConfirm={() => {
            activeConfirmHandler()
            setActiveConfirm(false)
          }}
        >
          <h4>{activeConfirmTitle}</h4>
        </ConfirmDialog>
      )}
      <h1>{tc("memberPermissions")}</h1>
      <div className="config-container">
        <Container className="config-container">
          <Title>{tc("allowMembersMoveOthersOperationalTasks")}</Title>
          <ToggleButtonGroup
            type="radio"
            className="TeamConfig-toggleButtonGroup"
            name="allowTaskTransfer"
            defaultValue={allowTaskTransfer}
            onChange={(value) => {
              dispatch(teamStatus.allowTaskTransfer({ allowTaskTransfer: value }))
                .then(() => {
                  dispatch(message.success(t("adhoc.memberPermissionsChanged")));
                });
            }}
          >
            <ToggleButton
              value={true}
              variant="light"
              id="teamconfig-movetasks_yes"
              className="TeamConfig-radioButton"
            >
              {tc("yes")}
            </ToggleButton>
            <ToggleButton
              value={false}
              variant="light"
              id="teamconfig-movetasks_no"
              className="TeamConfig-radioButton"
            >
              {tc("no")}
            </ToggleButton>
          </ToggleButtonGroup>
        </Container>
      </div>

      <div className="config-container">
        <Container className="config-container">
          <Title>{tc("membersGoDirectlyToMemberPlan")}</Title>
          <ToggleButtonGroup
            type="radio"
            className="TeamConfig-toggleButtonGroup"
            name="directToMemberPlan"
            defaultValue={directToMemberPlan}
            onChange={(value) => {
              dispatch(teamStatus.directToMemberPlan({ directToMemberPlan: value }))
                .then(() => {
                  dispatch(message.success(t("adhoc.memberPermissionsChanged")));
                });
            }}
          >
            <ToggleButton
              value={true}
              variant="light"
              id="teamconfig-memberplan_yes"
              className="TeamConfig-radioButton"
            >
              {tc("yes")}
            </ToggleButton>
            <ToggleButton
              value={false}
              variant="light"
              id="teamconfig-memberplan_no"
              className="TeamConfig-radioButton"
            >
              {tc("no")}
            </ToggleButton>
          </ToggleButtonGroup>
        </Container>
      </div>
      <hr />
      <h1>{tc("simulationMode")}</h1>
      {!isInPlanningMode && (
        <Button title={tc("enterSimulationMode")} onClick={() => dispatch(teamStatus.startPlanningMode())}>
          {tc("simulationModeUpper")}
        </Button>
      )}
      {!isCurrentPlanner && isInPlanningMode && (
        <Button disabled title={tc("isInSimulationMode", { initials: otherPlannerInitials })} variant="danger">
          {tc("simulationModeOccupied")}
        </Button>
      )}
      {isCurrentPlanner && isInPlanningMode && (
        <Button
          disabled={!isCurrentPlanner}
          variant="danger"
          onClick={() => {
            setActiveConfirm(true)
            setActiveConfirmHandler(() => () =>
              dispatch(teamStatus.discardPlanningModeChanges()).then(() => {
                if (isProjects) {
                  dispatch(integrationSheets.fetchProjectTemplateSheets())
                  dispatch(integrationSheets.fetchActionSheets())
                  dispatch(integrationSheets.fetchSapSheets())
                }
                if (isAnalyses) {
                  dispatch(integrationSheets.fetchSampleSheets())
                  dispatch(integrationSheets.fetchLimsSheets())
                }
                dispatch(loading.fetchAll(location.pathname))
              })
            )
            setActiveConfirmTitle(tc("areYouSureDiscardSimulation"))
          }}
          title={isCurrentPlanner ? tc("exitSimulationMode") : tc("isInSimulationMode", { initials: otherPlannerInitials })}
        >
          {tc("exitSimulation")}
        </Button>
      )}
      <hr/>
      <h1>{tc("reports")}</h1>
      <Button onClick={() => setShowReport(true)}>{tc("reportGenerator")}</Button>
      <hr />
      <h1>{tc("changeLogs")}</h1>
      <Button
        onClick={() => {
          // Pre-fetch begge logs så skift er lynhurtigt
          Promise.all([
            dispatch(logging.fetchLog()),
            dispatch(logging.fetchInstrumentLog()),
            dispatch(logging.fetchSampleLog())
          ]).then(() => {
            setShowLog(true)
          })
        }}
      >
        {tc("showLog")}
      </Button>
    </div>
  )
}
